import router from "@/router";
import axios from "axios";
import { baseUrl } from "./settings";
import { logout } from "@/utils/auth";
import store from "@/store/index";
import Vue from "vue";

axios.defaults.withCredentials = true;

export async function postApi(path, data, options = {}) {
  if (!store.state.auth.success && !options.skipAuth) {
    //reroute();
    return;
  }

  if (!options.skipAuth) path = `secure/${path}`;
  if (!options.skipDataObject) data = { data: data };

  try {
    //console.log(`${baseUrl}/${path}`, data);
    const res = await axios.post(`${baseUrl}/${path}`, data);
    if (!options.fullDataObject) return res.data;

    return res;
  } catch (err) {
    console.error(err);
    if (err.response) {
      if (err.response.status === 401 && router.currentRoute.path != "/signout")
        logout(true);
      else if (err.response.status === 403)
        Vue.notify(
          "Access denied",
          `The request (${path}) was denied`,
          "warning"
        );
    }
    throw err;
  }
}

export function post(url, data, config) {
  return axios.post(url, data, config);
}

export function _delete(url, config) {
  console.log(url);
  return axios.delete(url, config);
}
